// extracted by mini-css-extract-plugin
module.exports =  {"logoTitle":"jut__LogoTitle__logoTitle","title":"jut__LogoTitle__title","logo":"jut__LogoTitle__logo"};